import { breakpoints, Button, Dialog, Spacer } from '@spritz-finance/ui'
import React, { useCallback, useImperativeHandle, useRef, useState } from 'react'
import styled from 'styled-components'

type OnConfirmed = () => Promise<any> | any

export type ConfirmationDialogMethods = {
    confirm: (onConfirmed: OnConfirmed) => any | Promise<any>
}

type ConfirmationDialogProps = {
    confirmText?: string
    cancelText?: string
    children?: React.ReactNode
}

export const ContentContainer = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
`

const ActionContainer = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: center;
`

export const ContentSizer = styled.div`
    display: flex;
    flex-direction: column;
    width: 418px;
    ${breakpoints.xsmall} {
        width: unset;
    }
`

export const ConfirmationDialog = React.forwardRef<
    ConfirmationDialogMethods,
    ConfirmationDialogProps
>(({ children, confirmText = 'Continue', cancelText = 'Go back' }, ref) => {
    const [open, setOpen] = useState(false)
    const onConfirmed = useRef<OnConfirmed | undefined>(undefined)

    useImperativeHandle(ref, () => ({
        confirm: (_onConfirmed) => {
            onConfirmed.current = _onConfirmed
            setOpen(true)
        },
    }))

    const handleConfirmation = useCallback(() => {
        onConfirmed.current?.()
        setOpen(false)
    }, [])

    return (
        <Dialog open={open} onClose={() => setOpen(false)}>
            <Dialog.Content minWidth={418}>
                <ContentSizer>
                    <Spacer height={24} />
                    <ContentContainer>{children}</ContentContainer>
                    <Spacer height={32} />
                    <ActionContainer>
                        <Button.CTA variant="secondary" onClick={() => setOpen(false)}>
                            {cancelText}
                        </Button.CTA>
                        <Spacer width={16} />
                        <Button.CTA onClick={handleConfirmation}>{confirmText}</Button.CTA>
                    </ActionContainer>
                    <Spacer height={16} />
                </ContentSizer>
            </Dialog.Content>
        </Dialog>
    )
})
